import React from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  CRIF_LONG_CONSENT_CLAUSES,
  CRIF_LONG_CONSENT_INTRO,
  CRIF_LONG_CONSENT_TITLE,
  CRIF_PRIVACY_POLICY_URL,
  CRIF_WITHDRAWAL_COPY,
} from "../../constants/crifConsent";

export default function CrifConsentDialog({
  open,
  onClose,
  onAccept,
  showAccept = true,
}) {
  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <AppBar
        sx={{
          position: "relative",
          background: "white",
          color: "black",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 1, flex: 1, fontWeight: 600, fontSize: 16 }}>
            {CRIF_LONG_CONSENT_TITLE}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, pb: 12, overflowY: "auto" }}>
        <Typography sx={{ fontSize: 13, mb: 2, lineHeight: 1.5 }}>
          {CRIF_LONG_CONSENT_INTRO}
        </Typography>
        {CRIF_LONG_CONSENT_CLAUSES.map((clause) => (
          <Typography key={clause.id} sx={{ fontSize: 13, mb: 1.5, lineHeight: 1.5 }}>
            <strong>{clause.id}.</strong> {clause.text}
          </Typography>
        ))}
        <Box sx={{ mt: 2, p: 2, background: "#f6f3fb", borderRadius: 1 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1 }}>
            {CRIF_WITHDRAWAL_COPY.heading}
          </Typography>
          <Typography sx={{ fontSize: 13, mb: 1, lineHeight: 1.5 }}>
            {CRIF_WITHDRAWAL_COPY.body}
          </Typography>
          {CRIF_WITHDRAWAL_COPY.channels.map((ch) => (
            <Typography key={ch.label} sx={{ fontSize: 12, mb: 0.5, lineHeight: 1.4 }}>
              <strong>{ch.label}:</strong> {ch.value}
            </Typography>
          ))}
          <Typography sx={{ fontSize: 12, mt: 1 }}>
            CIC privacy policy:{" "}
            <a href={CRIF_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
              {CRIF_PRIVACY_POLICY_URL}
            </a>
          </Typography>
        </Box>
      </Box>
      {showAccept && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            background: "white",
            boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            className="btn-submit"
            onClick={onAccept}
          >
            I Accept
          </Button>
        </Box>
      )}
    </Dialog>
  );
}
